import { render } from "./CampaignLocaleDistribution.vue?vue&type=template&id=08de0f08&scoped=true"
import script from "./CampaignLocaleDistribution.vue?vue&type=script&lang=js"
export * from "./CampaignLocaleDistribution.vue?vue&type=script&lang=js"

import "./CampaignLocaleDistribution.vue?vue&type=style&index=0&id=08de0f08&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08de0f08"]])

export default __exports__